<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {OrderSummaryMixin} from '@/components/booking/mixins/OrderSummaryMixin.vue'

    //TODO Need total price calc global refactoring, now it is workaround for current order summary component solution
    @Component
    export class OrderSummaryBase extends OrderSummaryMixin {
        @Prop({default: false, type: Boolean}) prebooked
        @Prop({default: () => [], type: Array}) extraServices
        @Prop({default: () => ({}), type: Object}) additionalOptions
        // TODO: Flight Booking page - prop "additionalOptions". Expected Object, got Array
        @Prop({default: () => false, type: Boolean}) free
        @Prop() prepareBookResponse

        @Prop() searchRequest
    }

    export default OrderSummaryBase
</script>
